import React, { useEffect, useState, useRef } from 'react';
import {
  Row,
  Col,
  Spin,
  Select,
  Input,
  Tooltip,
  Space,
  Dropdown,
  Button,
} from 'antd';
import { useSelector, useDispatch } from 'react-redux';

import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import utc from 'dayjs/plugin/utc';
import { useParams } from 'react-router-dom';
import httpInjectorService from 'services/http-injector.service';
import SprintModal from './sprintmodal';
import Timelinesubtaskmodal from './Timelinesubtaskmodal';
import { setTimelineFilteredReqbody } from 'store/actions';
import { setTimelinefilter } from 'store/actions';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';

import {
  RightOutlined,
  DownOutlined,
  PlusOutlined,
  ThunderboltOutlined,
  CheckOutlined,
  CloseOutlined,
  MenuOutlined,
  EllipsisOutlined,
} from '@ant-design/icons';
import { MdOutlinePerson } from 'react-icons/md';
import SkeletonWithLoaders from 'components/common/Spinner';
import UserAvatar from '../../../../components/userAvatar/index';
import Cookies from 'js-cookie';
// import TimelineEpicmodal from './TimelineEpicmodal';
import TimelineEpicmodal from './TimelineEpicmodal';
import { setassigneelist } from 'store/actions';
import { setTaskstatuslist } from 'store/actions';
import TimelineTaskmodal from './TimelineTaskmodal';
import { toast } from 'react-toastify';
import TimelineMenu from './TimelineMenu';
import { SearchIcon, AddIcon } from '@chakra-ui/icons';
import { Segmented } from 'antd';
import { Card } from 'antd';
import { setSprintlist } from 'store/actions';
import { setTimelineEpicList } from 'store/actions';
import { setEpicTaskList } from 'store/actions';

import { Badge, HStack, Flex, Box } from '@chakra-ui/react';
import ResizableBar from './ResizableBar';

// ===== DnD-Kit Imports  (NEW) =====
import {
  DndContext,
  useDroppable,
  DragOverlay,
  useSensor,
  useSensors,
  PointerSensor,
  closestCenter,
} from '@dnd-kit/core';
import {
  useSortable,
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import EpicProgressBar from './EpicProgressBar';
import { color } from 'framer-motion';
// ===================================

dayjs.extend(isoWeek);
dayjs.extend(utc);

const items = [
  {
    key: '1',
    label: 'Export as CSV',
  },
];

const TIME_SCALES = {
  daily: 1,
  weekly: 7,
  monthly: 20,
  quarterly: 90,
};

const COLORS = {
  sprint: '#29e2a4ff',
  epic: '#d592edff',
  task: '#ebb78fff',
  todayLine: '#2563eb',
};
// ---------- Draggable Task Wrapper (NEW) ----------
// ---------- Draggable Task Wrapper (UPDATED) ----------

const DraggableTask = ({ task, epicId, children, onTaskClick,  activeType }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: task.issue_id, // unique task id
    data: {
      type: 'TASK', // important
      epicId, // source epic
    },
    disabled: activeType === 'EPIC', 
  });
  const handlePointerUp = () => {
    if (!isDragging) {
      onTaskClick?.(task);
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: 'grab',
      }}
      {...attributes}
      {...listeners}
    >
      <div
        onClick={(e) => {
          if (!isDragging) {
            onTaskClick?.(task);
          }
        }}
        style={{ pointerEvents: isDragging ? 'none' : 'auto' }}
      >
        {children}
      </div>
    </div>
  );
};

const SortableEpic = ({ epicId, epicObj, children }) => {
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: epicId,
    data: {
      type: 'EPIC',
      epicId,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
    opacity: isDragging ? 0.9 : 1,
    // background: isDragging
    //   ? epicObj?.color || epicObj?.epic_colour || '#884B9E'
    //   : '#fff',
    // border: isDragging
    //   ? `2px solid ${epicObj?.color || epicObj?.epic_colour || '#884B9E'}`
    //   : '1px solid #e5e7eb',
    // boxShadow: isDragging
    //   ? `0 10px 25px ${epicObj?.color || epicObj?.epic_colour || '#884B9E'}55`
    //   : '0 2px 6px rgba(0,0,0,0.08)',
    // borderRadius: 8,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div {...attributes} {...listeners}>
        {children}
      </div>
    </div>
  );
};
// ---------- Droppable Epic Wrapper (NEW) ----------
// EpicDroppable.jsx
// ---------- Droppable Epic Wrapper (UPDATED) ----------
const EpicDroppable = ({ epicId, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `drop-${epicId}`, // ✅ unique droppable id from epic_id
    data: { epicId }, // ✅ pass epic_id for target
  });

  return (
    <div
      ref={setNodeRef}
      style={{ background: isOver ? '#e0f7fa' : 'transparent' }}
    >
      {children}
    </div>
  );
};
const TimelineDashboard = () => {
  const { id: projectId } = useParams();
  const [sprints, setSprints] = useState([]);
  const [epics, setEpics] = useState({});
  const [loading, setLoading] = useState(false);
  const [scale, setScale] = useState('weekly');
  const [lastScale, setLastScale] = useState('weekly');
  const [expandedEpics, setExpandedEpics] = useState({});
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [epicsState, setEpicsState] = useState({});
  const [activeTask, setActiveTask] = useState(null);
  const [epiclist, setEpicList] = useState(null);
  const [epicmodalVisible, setEpicmodalVisible] = useState(false);
  const [selectedEpic, setSelectedEpic] = useState(null);
  const [taskmodalvisibe, setTaskModalvisible] = useState(false);
  const [selectedTask, setselectedTask] = useState(false);
  const [openSubTaskModal, setOpenSubTaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [taskType, setTaskType] = useState('task');

  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedEpics, setSelectedEpics] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [expandedSprintId, setExpandedSprintId] = useState(null);
  const hasMounted = useRef(false);
  const timelineScrollRef = useRef(null); // timeline container (right side)
  const scrollbarRef = useRef(null); // bottom fixed scrollbar
  const [timelineWidth, setTimelineWidth] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [showsprintmodal, setshowSprintModal] = useState(false);
  const [recentlyCreatedTask, setRecentlyCreatedTask] = useState(null);
  const workScrollRef = useRef(null);
  const [selectedfilterAssignee, setSelectedfilterAssignee] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [checkedEpicIds, setCheckedEpicIds] = useState([]);
  const dropdownRef = useRef(null);
  const [sidebarWidth, setSidebarWidth] = useState(400);
  const [issueTypes, setIssueTypes] = useState([]);
  const [selectedIssueTypeId, setSelectedIssueTypeId] = useState(null);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const workHeaderRef = useRef(null);
  const [activeType, setActiveType] = useState(null);
  const [isFilterMode, setIsFilterMode] = useState(false);


  const { Option } = Select;

  const MS_PER_DAY = 86400000;

  // total width of timeline

  const dispatch = useDispatch();

  // Tracks which epic shows the input box
  const [showTaskInputForEpic, setShowTaskInputForEpic] = useState({});
  const timelineRef = useRef(null);
  const roleId = Number(Cookies.get('task-role-id'));

  // Tracks the task name being typed
  const [newTaskTitles, setNewTaskTitles] = useState({});

  // show/hide the input
  const [showCreateEpicInput, setShowCreateEpicInput] = useState(false);
  // text typed by the user
  const [newEpicName, setNewEpicName] = useState('');
  // NEW

  const assigneeList = useSelector(
    (state) => state?.Authentication?.assigneelist,
  );
  const status = useSelector(
    (status) => status?.Authentication?.taskstatuslist,
  );

  const TimelinesprintList = useSelector(
    (state) => state?.Authentication?.sprintlist || [],
  );

  const TimelineepicList = useSelector(
    (state) => state?.Authentication?.timelineepiclist || [],
  );

  const TimelinetaskList = useSelector(
    (state) => state?.Authentication?.epictasklist || [],
  );

  const leftColWidth = 350;
  const employeePopoverRef = useRef();
  const ms = (d) => (d ? dayjs.utc(d).local().valueOf() : null);
  const isEditable = [1, 2, 3].includes(roleId);
  // ----- DnD Sensors (NEW) -----
  // const sensors = useSensors(useSensor(PointerSensor));
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    setEpicsState(epics);
    getIssueTypes(); // clone it as needed
  }, [epics]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 0, // consider it a drag if moved more than 5px
      },
    }),
  );

  const fetchData = async () => {
    try {
      const [sprintRes, epicRes, taskRes] = await Promise.all([
        httpInjectorService.timeline_Sprintlist(`?project_id=${projectId}`),
        httpInjectorService.timeline_Epiclist(`?project_id=${projectId}`),
        httpInjectorService.gettimelinetask(`?project_id=${projectId}`),
      ]);
      dispatch(
        setSprintlist(sprintRes?.status === 'success' ? sprintRes.data : []),
      );
      dispatch(
        setTimelineEpicList(epicRes?.status === 'success' ? epicRes.data : []),
      );
      dispatch(
        setEpicTaskList(taskRes?.status === 'success' ? taskRes.data : []),
      );
    } catch (err) {
      dispatch(setSprintlist([]));
      dispatch(setTimelineEpicList([]));
      dispatch(setEpicTaskList([]));
    }
  };

  const handleClear = () => {
    setSelectedfilterAssignee([]);
    fetchData();
  };

  // useEffect(() => {
  //   if (
  //     !TimelineepicList.length &&
  //     !TimelinetaskList.length &&
  //     !TimelinesprintList.length
  //   )
  //     return;

  //   // Group tasks by epic_id
  //   const taskMap = {};
  //   TimelinetaskList.forEach((t) => {
  //     const eId = t.epic_id || 'no-epic';
  //     if (!taskMap[eId]) taskMap[eId] = [];
  //     taskMap[eId].push(t);
  //   });

  //   // Merge epics + tasks
  //   const grouped = {};
  //   TimelineepicList.forEach((epic) => {
  //     grouped[epic.epic_id] = {
  //       epic_id: epic.epic_id,
  //       name: epic.epic_name,
  //       description: epic.description,
  //       start_date: epic.start_date,
  //       due_date: epic.due_date,
  //       epic_key: epic.epic_key,
  //       epic_status: epic.epic_status,
  //       epic_labelids: epic.labels_id,
  //       epic_assignee: epic.assignee_id,
  //       epic_story_points: epic.epic_story_points,
  //       task_status_count: epic.issue_status_count,
  //       color: epic.epic_colour,
  //       tasks: taskMap[epic.epic_id] || [],
  //       position: epic.position,
  //     };
  //   });

  //   // Handle orphan tasks (no epic)
  //   if (taskMap['no-epic']) {
  //     grouped['no-epic'] = {
  //       epic_id: 'no-epic',
  //       name: 'No Epic',
  //       tasks: taskMap['no-epic'],
  //     };
  //   }

  //   setSprints(TimelinesprintList);
  //   setEpics(grouped);
  //   setEpicsState(grouped);

  //   const initialExpanded = {};
  //   Object.keys(grouped).forEach((epicId) => {
  //     initialExpanded[epicId] = false;
  //   });
  //   setExpandedEpics(initialExpanded);
  // }, [TimelinesprintList, TimelineepicList, TimelinetaskList]);


  useEffect(() => {
  if (
    !TimelineepicList?.length &&
    !TimelinetaskList.length &&
    !TimelinesprintList.length
  )
    return;

  // Group tasks by epic_id (normal fetch case)
  const taskMap = {};
  TimelinetaskList.forEach((t) => {
    const eId = t.epic_id || 'no-epic';
    if (!taskMap[eId]) taskMap[eId] = [];
    taskMap[eId].push(t);
  });

  const grouped = {};

  TimelineepicList.forEach((epic) => {
    const tasksFromSeparateApi = taskMap[epic.epic_id];
    const tasksFromFilterApi = epic.issues; // 👈 filter API tasks

    grouped[epic.epic_id] = {
      epic_id: epic.epic_id,
      name: epic.epic_name,
      description: epic.description,
      start_date: epic.start_date,
      due_date: epic.due_date,
      epic_key: epic.epic_key,
      epic_status: epic.epic_status,
      epic_labelids: epic.labels_id,
      epic_assignee: epic.assignee_id || epic.epic_assignee_id,
      epic_story_points: epic.epic_story_points,
      task_status_count: epic.issue_status_count,
      color: epic.epic_colour,
     tasks: isFilterMode
      ? (tasksFromFilterApi ?? [])
      : (tasksFromSeparateApi ?? []),
      position: epic.position,
    };
  });

  // Handle orphan tasks (only for normal fetch case)
  if (taskMap['no-epic']) {
    grouped['no-epic'] = {
      epic_id: 'no-epic',
      name: 'No Epic',
      tasks: taskMap['no-epic'],
    };
  }

  setSprints(TimelinesprintList);
  setEpics(grouped);
  setEpicsState(grouped);
 

  const initialExpanded = {};
  Object.keys(grouped).forEach((epicId) => {
    initialExpanded[epicId] = false;
  });

  setExpandedEpics(initialExpanded);
}, [TimelinesprintList, TimelineepicList, TimelinetaskList]);

  const fetchFilteredData = async () => {
    try {
      const body = {
        project_id: projectId,
        assignee_id: selectedfilterAssignee?.length
          ? selectedfilterAssignee
          : [],
        issue_status: selectedStatuses.length ? selectedStatuses : [],
        epic_id: selectedEpics.length ? selectedEpics : [],
        issue_type_id: selectedIssue.length ? selectedIssue : [],
      };
    
      const response = await httpInjectorService.timelinefilterDetails(body);
      dispatch(setTimelineFilteredReqbody(body));
      if (response.status === 'success' && response.data?.epics) {
        setIsFilterMode(true);
        const epicData = response?.data.epics || [];
      
        dispatch(
          setTimelineEpicList(
            response.status === 'success' ? response.data?.epics : [],
          ),
        );

        const grouped = {};
        epicData.forEach((epic) => {
          grouped[epic.epic_id] = {
            epic_id: epic.epic_id,
            name: epic.epic_name,
            description: epic.description,
            start_date: epic.epic_start_date,
            due_date: epic.epic_due_date,
            epic_key: epic.epic_key,
            epic_status: epic.epic_status,
            epic_labelids: epic.labels_id,
            epic_assignee: epic.assignee_id,
            epic_story_points: epic.epic_story_points,
            tasks: epic.issues || [],
            task_status_count: epic.issue_status_count,
            position: epic.position,
          };
        });

        setEpics(grouped);
        setEpicsState(grouped);

        // Expand all by default
        const expanded = {};
        Object.keys(grouped).forEach((id) => (expanded[id] = true));
        setExpandedEpics(expanded);
      } else {
        setEpics({});
        setEpicsState({});
      }
    } catch (error) {
      throw error;
    } finally {
      // setLoading(false);
    }
  };

  const getIssueIcon = (type) => {
    switch (type?.toUpperCase()) {
      case 'TASK':
        return <TaskObject size="medium" />;
      case 'BUG':
        return <BugObject size="medium" />;
      case 'STORY':
        return <StoryObject size="medium" />;
      default:
        return <TaskObject size="medium" />;
    }
  };

  const getIssueTypes = async () => {
    try {
      const response = await httpInjectorService.getIssueTypes();

      if (response.status === 'success') {
        setIssueTypes(response.data);
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (!workScrollRef.current || !workHeaderRef.current) return;

    const panel = workScrollRef.current;
    const header = workHeaderRef.current;

    const updateHeader = () => {
      const rect = panel.getBoundingClientRect();

      header.style.width = rect.width + 'px';
      header.style.left = rect.left + 'px';
    };

    updateHeader(); 

    // Watch for panel width changes
    const observer = new ResizeObserver(updateHeader);
    observer.observe(panel);

    window.addEventListener('resize', updateHeader);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateHeader);
    };
  }, []);

  const sortedEpics = Object.entries(epicsState)
    .filter(([epicId, epicObj]) =>
      epicObj?.name?.toLowerCase().includes(searchQuery.toLowerCase()),
    )
    .sort((a, b) => (a[1].position || 0) - (b[1].position || 0));
  

  useEffect(() => {
    const isFilterApplied =
      selectedfilterAssignee?.length > 0 ||
      selectedStatuses?.length > 0 ||
      selectedEpics?.length > 0 ||
      selectedIssue?.length > 0;

    dispatch(setTimelinefilter(isFilterApplied));

    if (isFilterApplied) {
      fetchFilteredData();
    } else {
      dispatch(setTimelinefilter(isFilterApplied));
      fetchData();
    }
  }, [selectedfilterAssignee, selectedStatuses, selectedEpics, selectedIssue]);

  const getEpiclist = async () => {
    const queryParams = `?project_id=${projectId}`;
    // const projectId=project_id.id
    try {
      const response = await httpInjectorService.get_epic(queryParams);

      if (response.status === 'success') {
        setEpicList(response.data);
      }
    } catch (error) {
      throw error;
    }
  };

  const handleScaleChange = (value) => {
    if (value === 'daily') {
      // clicking "Today" → go back to last non-daily scale
      scrollToActiveDay();
      setScale(lastScale);
    } else {
      // clicking any other scale → update lastScale and current scale
      setLastScale(value);
      setScale(value);
    }
  };

  const getprojectAssignedEmployee = async () => {
    try {
      let response =
        await httpInjectorService.getProjectAssignedEmployeelist(projectId);
      if (response.status === 'success') {
        // setAssignedEmployee(response.data);
        dispatch(setassigneelist(response.data));
      } else {
        dispatch(setassigneelist([]));
      }
    } catch (error) {
      throw error;
    }
  };

  const listBoardStatus = async () => {
    try {
      const response = await httpInjectorService.ListBoardStatus(projectId);
      if (response.status === 'success' && Array.isArray(response.data)) {
        const statusList = response?.data;
        dispatch(setTaskstatuslist(statusList));
        // setStatus(statusList);
        // setColumnOrder(statusList?.map((s) => s.status_name)); // 👈 track order separately

        // Initialize empty task arrays dynamically
      } else {
        // setStatus([]);
        dispatch(setTaskstatuslist([]));

        // set({});
      }
    } catch (error) {
      throw error;
    }
  };

  // useEffect(() => {
  //   const loadData = async () => {
  //     if (!hasMounted.current) {
  //       setLoading(true); // First load only
  //       await fetchData();
  //       setLoading(false);
  //       hasMounted.current = true;
  //     } else {
  //       // On projectId change (after first mount)
  //       fetchData(); // Without loading
  //     }

  //     // These run on every projectId change
  //     getprojectAssignedEmployee();
  //     listBoardStatus();
  //     getEpiclist();
  //   };

  //   loadData();
  // }, [projectId]);

  useEffect(() => {
    let isCancelled = false;

    const loadData = async () => {
      setLoading(true); // always show loader on project change

      try {
        // Minimum loader visibility
        await new Promise((resolve) => setTimeout(resolve, 500));

        await Promise.all([
          fetchData(),
          getprojectAssignedEmployee(),
          listBoardStatus(),
          getEpiclist(),
        ]);
      } catch (error) {
        console.error('Error while loading data:', error);
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      isCancelled = true; // cleanup to avoid stuck loader
    };
  }, [projectId]);
  function scrollToActiveDay() {
    if (!timelineScrollRef.current) return;

    const activeDay = dayjs(); // today, or pass as argument if needed

    // Calculate how far from the left the active day is
    // const scrollLeftPos = ((activeDay.valueOf() - allStart) / MS_PER_DAY) * PIXELS_PER_DAY;
    const scrollLeftPos =
      ((activeDay.valueOf() - allStartMs) / MS_PER_DAY) * PIXELS_PER_DAY;

    // Optional: center the active day in the viewport
    const containerWidth = timelineScrollRef.current.clientWidth;
    const centeredScrollLeft =
      scrollLeftPos - containerWidth / 5 + PIXELS_PER_DAY;

    timelineScrollRef.current.scrollTo({
      left: centeredScrollLeft,
      behavior: 'smooth', // optional for smooth scrolling
    });
  }

  useEffect(() => {
    if (timelineScrollRef.current) {
      scrollToActiveDay();
    }
  }, [timelineScrollRef.current, scale]);

  // ---------- Drag End Handler (NEW) ----------
  // ---------- Drag End Handler (UPDATED) ----------
  const handleDragEnd = async (event) => {
  
    const { active, over } = event;
    const taskType = active.data.current?.type;

    // 🔹 Epic drag
   if (taskType === 'EPIC') {
  if (!over || active.id === over.id) return;

  const epicArray = sortedEpics.map(([_, epicObj]) => epicObj);


  const oldIndex = epicArray.findIndex(
    (e) => String(e.epic_id) === String(active.id)
  );

  const newIndex = epicArray.findIndex(
    (e) => String(e.epic_id) === String(over.id)
  );

  if (oldIndex === -1 || newIndex === -1) return;

  const reordered = arrayMove(epicArray, oldIndex, newIndex);

  const updatedWithPositions = reordered.map((epic, index) => ({
    ...epic,
    position: index + 1,
  }));

  const newState = {};
  updatedWithPositions.forEach((epic) => {
    newState[epic.epic_id] = epic;
  });

  setEpicsState(newState);

  await httpInjectorService.updateEpicposition({
    project_id: projectId,
    epics: updatedWithPositions.map((e) => ({
      epic_id: e.epic_id,
      position: e.position,
    })),
  });

  return;
}


    // 🔹 Task drag
    if (!over) {
      setActiveTask(null);
      return;
    }

    const taskId = active.id;
    const sourceEpicId = active.data.current?.epicId;
    const targetEpicId = over.data.current?.epicId;

    if (!targetEpicId || sourceEpicId === targetEpicId) {
      setActiveTask(null);
      return;
    }

    let movedTask = null;

    setEpicsState((prev) => {
      const sourceEpic = prev[sourceEpicId];
      const targetEpic = prev[targetEpicId];

      if (!sourceEpic || !targetEpic) return prev;

      movedTask = sourceEpic.tasks.find((t) => t.issue_id === taskId);
      if (!movedTask) return prev;

      return {
        ...prev,
        [sourceEpicId]: {
          ...sourceEpic,
          tasks: sourceEpic.tasks.filter((t) => t.issue_id !== taskId),
        },
        [targetEpicId]: {
          ...targetEpic,
          tasks: [...targetEpic.tasks, movedTask],
        },
      };
    });

    setActiveTask(null);

    try {
      await httpInjectorService.UpdateTimelineTaskEpic({
        issue_id: taskId,
        project_id: projectId,
        new_epic_id: targetEpicId,
      });
    } catch (err) {
      throw err;
    }
  };

  // ... other refs

  const PIXELS_PER_DAY = (() => {
    switch (scale) {
      case 'daily':
        return 45;
      case 'weekly':
        return 25;
      case 'monthly':
        return 10;
      case 'quarterly':
        return 3.5;
      default:
        return 20; // fallback
    }
  })();

  // Then compute DAY_WIDTH as before
  const scaleMultiplier = TIME_SCALES[scale] || 1;

  // Try sprint dates first
  const sprintStartDates = sprints
    ?.map(
      (s) =>
        Date.parse(s.start_date) ||
        Date.parse(s.created_at) ||
        Date.parse(s.updated_at),
    )
    .filter(Boolean);

  const sprintEndDates = sprints
    ?.map(
      (s) =>
        Date.parse(s.end_date) ||
        Date.parse(s.updated_at) ||
        Date.parse(s.created_at),
    )
    .filter(Boolean);

  // If no sprints, try epic dates
  let startDates = sprintStartDates;
  let endDates = sprintEndDates;

  if (startDates.length === 0 || endDates.length === 0) {
    const epicList = Object.values(epics).flat();

    startDates = epicList
      .map((e) => Date.parse(e.start_date) || Date.parse(e.created_at))
      .filter(Boolean);

    endDates = epicList
      .map(
        (e) =>
          Date.parse(e.end_date) ||
          Date.parse(e.updated_at) ||
          Date.parse(e.created_at),
      )
      .filter(Boolean);
  }

  // If no epics, try tasks inside epics
  if (startDates.length === 0 || endDates.length === 0) {
    const taskList = Object.values(epics).flatMap((ep) => ep.tasks || []);

    startDates = taskList
      .map((t) => Date.parse(t.start_date) || Date.parse(t.created_at))
      .filter(Boolean);

    endDates = taskList
      .map(
        (t) =>
          Date.parse(t.due_date) ||
          Date.parse(t.end_date) ||
          Date.parse(t.updated_at) ||
          Date.parse(t.created_at),
      )
      .filter(Boolean);
  }

  // const allStart = dayjs().startOf('day');
  const allStart = (() => {
    const today = dayjs().subtract(1, 'year').startOf('day');

    if (scale === 'monthly') {
      // Show one extra previous month (October if now November)
      return today.startOf('month').subtract(1, 'month');
    } else if (scale === 'weekly') {
      // Show previous week
      return today.startOf('week').subtract(1, 'week');
    } else if (scale === 'quarterly') {
      // Show previous quarter
      const currentMonth = today.month(); // 0–11
      const quarterStartMonth = Math.floor(currentMonth / 3) * 3;
      return today
        .month(quarterStartMonth)
        .startOf('month')
        .subtract(3, 'month');
    }
    // daily or fallback
    return today.startOf('day');
  })();

  const allStartMs = allStart.valueOf ? allStart.valueOf() : Number(allStart);
  const allEnd = dayjs().add(2, 'year').endOf('day');
  const MS_PER_PIXEL = MS_PER_DAY / PIXELS_PER_DAY; // ms per pixel
  const allEndMs = allEnd.valueOf ? allEnd.valueOf() : Number(allEnd);
  const totalWidth = ((allEndMs - allStartMs) / MS_PER_DAY) * PIXELS_PER_DAY;
  // End 2 years from today

  // Generate months
  const months = [];
  if (scale === 'monthly') {
    let currentMonthStart = allStart.startOf('month');
    const endMonth = allEnd.endOf('month');

    while (
      currentMonthStart.isBefore(endMonth) ||
      currentMonthStart.isSame(endMonth, 'month')
    ) {
      months.push(currentMonthStart);
      currentMonthStart = currentMonthStart.add(1, 'month');
    }
  }

  const days = [];
  let t = allStart;
  while (t <= allEnd) {
    days.push(new Date(t));
    t += 86400000 * scaleMultiplier;
  }

  const handleCreateEpic = async () => {
    let response = await httpInjectorService.taskManagementAddEpic({
      project_id: projectId,
      epic_name: newEpicName.trim(),
    });
    if (response.status === 'success') {
      toast.success(response.message, {
        position: 'top-right',
        autoClose: 3000,
      });

      fetchData();

      setNewEpicName('');
      setShowCreateEpicInput(false);
    } else {
      toast.error(response.message, {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const handleOpentask = (task) => {
    setselectedTask(task);
    setTaskModalvisible(true);
    setEpicmodalVisible(false);
  };
  const handleOpenTaskInput = (epicId) => {
    setShowTaskInputForEpic((prev) => ({
      ...prev,
      [epicId]: true,
    }));
  };

  const handleOpenSubtask = (subtask) => {
    setSelectedSubtask(subtask);
    setOpenSubTaskModal(true);
    setTaskModalvisible(false);

    // onClose();
  };

  const handlesubtaskmodal = () => {
    setOpenSubTaskModal(false);
  };

  const handleEpicClick = (epicObj) => {
    setSelectedEpic(epicObj);
    setEpicmodalVisible(true);
    setTaskModalvisible(false);
    setOpenSubTaskModal(false);
  };

  const handleCloseEpicModal = () => {
    setSelectedEpic(null);
    setEpicmodalVisible(false);
  };

  const handletaskmodal = (task) => {
    setselectedTask({ ...task }); // 🔥 new object reference
    setTaskModalvisible(true);
  };

  const handleClosetaskmodal = () => {
    setTaskModalvisible(false);
  };

  const handleCreateTask = async (epicId, epicObj) => {
    const title = newTaskTitles[epicId]?.trim();
    if (!title) return;

    try {
      let response = await httpInjectorService.addtaskwithEpic({
        epic_id: epicId,
        project_id: projectId,
        issue_title: title,
        issue_type_id: selectedIssueTypeId,
        sprint_id: epicObj?.sprint_id || null,
      });
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        fetchData();
        // Clear input and hide the box
        setNewTaskTitles((prev) => ({ ...prev, [epicId]: '' }));
        setShowTaskInputForEpic((prev) => ({ ...prev, [epicId]: false }));
        setRecentlyCreatedTask(response.data);
        setshowSprintModal(true);

        // Optional: Refresh data (if needed)
        // await fetchData();
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (timelineRef.current && allStart) {
        const today = dayjs().startOf('day').valueOf();
        const offsetFromStart =
          ((today - allStart) / 86400000) * PIXELS_PER_DAY;

        timelineRef.current.scrollTo({
          left: offsetFromStart - 200,
          behavior: 'smooth',
        });
      }
    }, 100); // ⏱ Delay to ensure layout is rendered

    return () => clearTimeout(timeout);
  }, [allStart]);

  const handleSprintUpdateDates = async (
    sprintId,
    newStart,
    newEnd,
    details,
  ) => {
    try {
      let response = await httpInjectorService.UpdatesprintsDetails({
        sprint_id: sprintId,
        project_id: projectId,
        sprint_name: details.sprint_name,
        start_date: dayjs(newStart).format('YYYY-MM-DD'),
        end_date: dayjs(newEnd).format('YYYY-MM-DD'),
      });
      if (response.status === 'success') {
        // Update local state
        setSprints((prev) =>
          prev.map((s) =>
            s.sprint_id === sprintId
              ? {
                  ...s,
                  start_date: newStart, // store ms (number)
                  end_date: newEnd, // store ms (number)
                }
              : s,
          ),
        );
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      throw err;
    }
  };
  const handleTaskUpdateDates = async (taskId, newStart, newEnd, details) => {
    const scrollPos = timelineRef.current?.scrollLeft || 0;

    try {
      await httpInjectorService.Taskedit({
        issue_id: taskId,
        project_id: projectId,
        start_date: dayjs(newStart).format('YYYY-MM-DD'),
        due_date: dayjs(newEnd).format('YYYY-MM-DD'),
        task_title: details.task_title,
        task_status: details.task_status,
        sprint_id: details.sprint_id,
        epic_id: details.epic_id,
      });

      setEpicsState((prev) => {
        const updated = { ...prev };
        for (const epicId in updated) {
          updated[epicId] = {
            ...updated[epicId],
            tasks: updated[epicId].tasks.map((t) =>
              t.issue_id === taskId
                ? {
                    ...t,
                    task_title: details.issue_title,
                    task_status: details.issue_status,
                    sprint_id: details.sprint_id,
                    epic_id: details.epic_id,
                    start_date: newStart,
                    due_date: newEnd,
                  }
                : t,
            ),
          };
        }
        return updated;
      });

      // Restore scroll after render
      setTimeout(() => {
        if (timelineRef.current) {
          timelineRef.current.scrollLeft = scrollPos;
        }
      }, 0);
    } catch (err) {
      console.error('Error updating task dates', err);
    }
  };

 

  const handleEpicUpdateDates = async (epicId, newStart, newEnd, epicName) => {
    try {
      await httpInjectorService.UpdateEpicDetails({
        epic_id: epicId,
        project_id: projectId,
        epic_name: epicName,
        start_date: dayjs(newStart).format('YYYY-MM-DD'),
        due_date: dayjs(newEnd).format('YYYY-MM-DD'),
      });

      // Merge updated dates directly into epicsState
      setEpicsState((prev) => {
        const updated = { ...prev };
        updated[epicId] = {
          ...prev[epicId],
          epic_name: epicName,
          start_date: newStart,
          due_date: newEnd,
          tasks: [...(prev[epicId]?.tasks || [])],
        };

        return updated;
      });
    } catch (err) {
      console.error('Error updating epic dates', err);
    }
  };

  const toggleEpic = (epicName) => {
    setExpandedEpics((prev) => ({ ...prev, [epicName]: !prev[epicName] }));
  };

  const handleAssigneeClick = (user_id) => {
    setSelectedfilterAssignee((prev) => {
      let updated;
      if (prev.includes(user_id)) {
        updated = prev.filter((id) => id !== user_id);
      } else {
        updated = [...prev, user_id];
      }

      return updated;
    });
  };

  const MAX_VISIBLE = 4;
  const visible = assigneeList.slice(0, MAX_VISIBLE);
  const hidden = assigneeList.slice(MAX_VISIBLE);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const isOverlapping = (sprint, others) => {
    const startA = ms(sprint.start_date);
    const endA = ms(sprint.end_date);

    return others.some((other) => {
      if (other.sprint_id === sprint.sprint_id) return false;
      const startB = ms(other.start_date);
      const endB = ms(other.end_date);

      // Overlapping if not fully before or after
      return !(endA <= startB || startA >= endB);
    });
  };
  const TIMELINE_WIDTH = 2000;
  // const totalWidth = ((allEnd - allStart) / 86400000) * PIXELS_PER_DAY;
  const activeDay = dayjs();

  // Calculate active line horizontal LEFT offset
  // const activeLeft = ((activeDay.valueOf() - allStart) / MS_PER_DAY) * PIXELS_PER_DAY;
  const activeLeft =
    ((activeDay.valueOf() - allStartMs) / MS_PER_DAY) * PIXELS_PER_DAY;

  // Check if active day is actually inside the rendered range
  const isActiveInRange =
    activeDay.valueOf() >= allStart && activeDay.valueOf() <= allEnd;

  // prepare visible rows once in render
  const visibleRows = [];
  Object.entries(epicsState).forEach(([epicId, epic]) => {
    visibleRows.push({ type: 'epic', id: epicId, data: epic });
    if (expandedEpics[epicId]) {
      epic.tasks.forEach((task) =>
        visibleRows.push({ type: 'task', id: task.issue_id, data: task }),
      );
    }
  });

  //new
  const injectedCSS = `
.timeline-card-root { font-family: Inter, Arial, sans-serif; }
.timeline-header-row { display:flex; }
.timeline-header-inner > div { box-sizing: border-box; }
.timeline-card-root .resizer { background: transparent; }
/* Left panel */
.timeline-left { background: #fafafa; border-right: 1px solid #E2E8F0; }
.timeline-left .epic-row { height: 38px; border-bottom: 1px solid #E2E8F0; display:flex; align-items:center; padding:6px 10px; }
/* Right timeline */
.timeline-right { background: #f5f5f5; }
.timeline-right .timeline-row { height: 40px; }
/* scrollbar placeholder */
.timeline-bottom-scroll { height:12px; overflow-x:auto; overflow-y:hidden; }
`;
  const onWorkScroll = (e) => {
    const sc = e.target;
    if (timelineScrollRef.current)
      timelineScrollRef.current.scrollTop = sc.scrollTop;
  };

  const startResize = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = sidebarWidth;

    const onMouseMove = (moveEvent) => {
      const newWidth = startWidth + (moveEvent.clientX - startX);
      setSidebarWidth(Math.max(150, Math.min(newWidth, 1000)));
    };

    const stop = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', stop);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', stop);
  };

  const onTimelineScroll = (e) => {
    const sc = e.target;
    if (workScrollRef.current && sc) {
      // vertical sync
      workScrollRef.current.scrollTop = sc.scrollTop;
    }
    // horizontal header sync
    setScrollLeft(sc.scrollLeft || 0);

    // if you use a separate bottom scrollbar, keep it in sync
    if (scrollbarRef.current) scrollbarRef.current.scrollLeft = sc.scrollLeft;
  };

  const getEpicsTaskWithSubTasks = async () => {
    try {
      const reqBOdy = { project_id: projectId };
      if (checkedEpicIds.length > 0) {
        reqBOdy.epic_id = checkedEpicIds;
      }
      const response =
        await httpInjectorService.getProjectTaskSubTaskData(reqBOdy);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch epics tasks with subtasks:', error);
    }
  };

  const stripHtml = (html) => {
  if (!html) return '';
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

  const buildEpicTaskSubtaskCsv = (data) => {
    if (!data?.epics?.length) return '';

    const rows = [];

    data.epics.forEach((epic) => {
      epic.tasks.forEach((task) => {
        // If task has subtasks → create one row per subtask
        if (task.subtasks && task.subtasks.length > 0) {
          task.subtasks.forEach((sub) => {
            rows.push({
              project: data.project.name,
              project_key: data.project.key,
              epic_key: epic.key,
              epic_description: stripHtml(epic.epic_description),
              epic_summary: epic.summary,
              epic_assignee: epic.assignee,
              task_key: task.key,
              task_summary: task.summary,
              task_status: task.status,
              task_description:stripHtml(task.issue_description),
              task_startDate: task.startDate,
              task_dueDate: task.dueDate,
              task_assignee: task.assignee,
              subtask_key: sub.key,
              subtask_summary: sub.summary,
              subtask_status: sub.status,
              subtask_description:stripHtml(sub.subtask_description),
              subtask_startDate: sub.startDate,
              subtask_dueDate: sub.dueDate,
              subtask_assignee: sub.assignee,
            });
          });
        } else {
          // Task with NO subtasks
          rows.push({
            project: data.project.name,
            project_key: data.project.key,
            epic_key: epic.key,
            epic_summary: epic.summary,
            task_key: task.key,
            task_summary: task.summary,
            task_status: task.status,
            task_startDate: task.startDate,
            task_dueDate: task.dueDate,
            subtask_key: '',
            subtask_summary: '',
            subtask_status: '',
            subtask_startDate: '',
            subtask_dueDate: '',
          });
        }
      });
    });

    return convertRowsToCsv(rows);
  };

  const convertRowsToCsv = (rows) => {
    if (!rows || rows.length === 0) return '';

    const headers = Object.keys(rows[0]);

    // Convert headers → CAPITAL + SPACE
    const formattedHeaders = headers.map(
      (h) => `${h.replace(/_/g, ' ').toUpperCase()}`,
    );

    const csvRows = [formattedHeaders.join(',')];

    rows.forEach((row) => {
      const values = headers.map((h) => {
        const v = row[h] ?? '';
        return `${String(v).replace(/"/g, '""')}`;
      });
      csvRows.push(values.join(','));
    });

    return csvRows.join('\n');
  };

  const handleDownloadCsv = async () => {
    const apiData = await getEpicsTaskWithSubTasks(); 

    const csvString = buildEpicTaskSubtaskCsv(apiData);

    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.download = 'epics_tasks_subtasks.csv';
    link.click();

    URL.revokeObjectURL(url);
  };

  const handleMenuClick = (e) => {
    handleDownloadCsv();
  };

  //   if (loading) return (
  //   <Flex justify="center" align="center" w="100%" h="300px"  mt="200px">
  //     <SkeletonWithLoaders />
  //   </Flex>
  // );

  // helper
  const getIcon = (type, size = 18) => {
    switch (type?.toUpperCase()) {
      case 'TASK':
        return <TaskObject width={size} stroke="#0052CC" />;
      case 'STORY':
        return <StoryObject width={size} stroke="#36B37E" />;
      case 'BUG':
        return <BugObject width={size} stroke="#172B4D" />;
      default:
        return null;
    }
  };

  const getStatusColors = (status = '') => {
    const s = status.toUpperCase(); // normalize

    switch (s) {
      case 'DONE':
        return { bg: 'green.300', color: 'black' };

      case 'TO DO':
        return { bg: 'gray.300', color: 'black' };

      default:
        return { bg: 'blue.300', color: 'black' };
    }
  };

  const { bg, color } = getStatusColors(t.task_status);

  return (
    <Card
      style={{
        position: 'fixed',
        top: '175px',
        left: '50px',
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '16px',
        }}
      >
        {/* Time Scale Select */}
        <Input
          placeholder="Search Epics"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          allowClear
          prefix={<SearchIcon color="gray.400" />}
          style={{ width: 200 }}
          data-tour="timeline-search"
        ></Input>

        {/* Assignee Select (multi-select with checkboxes) */}
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }} data-tour="timeline-filters">
        <Space style={{ position: 'relative', display: 'flex' }}>
          {visible.map((a, index) => {
            const isSelected = selectedfilterAssignee.includes(a.user_id);
            return (
              <Tooltip key={a.user_id} title={a.username}>
                <div
                  onClick={() => handleAssigneeClick(a.user_id)}
                  style={{
                    border: isSelected
                      ? '2px solid #1677ff'
                      : '2px solid white',
                    borderRadius: '50%',
                    boxShadow: isSelected
                      ? '0 0 5px rgba(22,119,255,0.4)'
                      : 'none',
                    marginLeft: index === 0 ? 0 : -8,
                    cursor: 'pointer',
                    transition: '0.2s',
                    background: '#fff',
                  }}
                >
                  <UserAvatar username={a.username} size={32} />
                </div>
              </Tooltip>
            );
          })}

          {hidden?.length > 0 && (
            <div
              ref={dropdownRef}
              style={{
                position: 'relative',
                display: 'inline-block',
              }}
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  background: '#f5f5f5',
                  color: '#555',
                  fontSize: 13,
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: -8,
                  cursor: 'pointer',
                  border: '2px solid white',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setDropdownOpen((prev) => !prev);
                }}
              >
                +{hidden.length}
              </div>

              {/* Custom popup menu */}
              {dropdownOpen && (
                <div
                  style={{
                    position: 'absolute',
                    top: 40,
                    right: 0,
                    width: 220,
                    maxHeight: 300,
                    overflowY: 'auto',
                    background: '#fff',
                    border: '1px solid #f0f0f0',
                    borderRadius: 8,
                    padding: 8,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                    zIndex: 9999,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {hidden.map((a) => {
                    const isSelected = selectedfilterAssignee.includes(
                      a.user_id,
                    );
                    return (
                      <div
                        key={a.user_id}
                        onClick={() => handleAssigneeClick(a.user_id)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                          padding: '8px',
                          borderRadius: 6,
                          background: isSelected
                            ? 'rgba(22,119,255,0.08)'
                            : 'transparent',
                          cursor: 'pointer',
                          marginBottom: 6,
                        }}
                      >
                        <UserAvatar username={a.username} size={24} />
                        <span style={{ flex: 1, fontSize: 13 }}>
                          {a.username}
                        </span>
                        {isSelected && (
                          <span
                            style={{
                              color: '#1677ff',
                              fontWeight: 700,
                            }}
                          >
                            ✓
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </Space>

        {selectedfilterAssignee?.length > 0 && (
          <span
            onClick={handleClear}
            style={{
              cursor: 'pointer',
              color: '#1677ff',
              fontSize: 13,
              marginLeft: 8,
              textDecoration: 'underline',
            }}
          >
            Clear
          </span>
        )}

        {/* Status Select (multi-select with checkboxes) */}
        <Select
          mode="multiple"
          allowClear
          placeholder="Status"
          value={selectedStatuses}
          onChange={setSelectedStatuses}
          style={{ width: 200 }}
          options={status.map((status) => ({
            label: status.status_name,
            value: status.status_name,
          }))}
        />

        <Select
          mode="multiple"
          allowClear
          placeholder="Select Task type"
          value={selectedIssue}
          onChange={setSelectedIssue}
          style={{ width: 200 }}
          options={issueTypes?.map((task) => ({
            label: task.issue_type,
            value: task.issue_type_id,
          }))}
        />

        {/* Epic List Select (multi-select with checkboxes) */}
        <Select
          mode="multiple"
          allowClear
          placeholder="Select Epic"
          value={selectedEpics}
          onChange={setSelectedEpics}
          style={{ width: 200 }}
          options={epiclist?.map((epic) => ({
            label: `${epic.epic_key} - ${epic.epic_name}`,
            value: epic.epic_id,
          }))}
        />
        </div>

        <Space>
          <Dropdown
            menu={{
              items,
              onClick: (info) => {
                handleMenuClick(info);
              },
            }}
            placement="bottomLeft"
          >
            <Button icon={<EllipsisOutlined />}></Button>
          </Dropdown>
        </Space>
      </div>
      {loading ? (
        <Flex justify="center" align="center" w="100%" h="300px" data-tour="timeline-grid" >
          <SkeletonWithLoaders />
        </Flex>
      ) : (
        <div
          className="timeline-card-root"
          style={{
            position: 'fixed',
            top: '300px',
            left: '55px',
            right: '20px',
            bottom: '20px',
            width: 'calc(100% - 55px)',
            height: 'calc(100vh - 320px)',
            border: '1px solid #E2E8F0',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden', // <-- changed from overflowY: 'auto'
            zIndex: 1000,
            transition: 'height 0.2s ease',
            background: '#fff',
          }}
        >
          <style dangerouslySetInnerHTML={{ __html: injectedCSS }} />
          <div
            className="timeline-header-row"
            style={{ display: 'flex', flexShrink: 0 }}
          >
            <div
              ref={workHeaderRef}
              style={{
                width: sidebarWidth,
                minWidth: sidebarWidth,
                maxWidth: sidebarWidth,
                height: 52,
                boxSizing: 'border-box',
                borderBottom: '1px solid #E2E8F0',
                padding: '6px 12px',
                borderRight: '1px solid #E2E8F0',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 600,
                background: '#fafafa',
                zIndex: 1200,
                fontSize: 18,
              }}
            >
              Work
            </div>
            <div
              style={{
                flex: 1,
                overflow: 'hidden',
                position: 'relative',
                height: 52,
                background: '#f8fafc',
                borderBottom: '1px solid #E2E8F0',
                
              }}
              data-tour="timeline-grid"
              
            >
              <div
                className="timeline-header-inner"
                style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  height: '100%',
                  transform: `translateX(-${scrollLeft}px)`,
                  display: 'flex',
                  alignItems: 'center',
                  zIndex: 1100,
                  whiteSpace: 'nowrap',
                }}
              >
                {Array.from({ length: days }).map((_, i) => (
                  <div
                    key={i}
                    style={{
                      width: PIXELS_PER_DAY,
                      textAlign: 'center',
                      fontSize: 12,
                      fontWeight: 600,
                      paddingTop: 10,
                    }}
                  >
                    {dayjs(allStart + i * 86400000).format('DD MMM')}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flex: 1,
              minHeight: 0 /* important for scroll */,
            }}
          >
            <div
              ref={workScrollRef}
              onScroll={onWorkScroll}
              className="timeline-left"
              style={{
                width: sidebarWidth,
                minWidth: sidebarWidth,
                maxWidth: sidebarWidth,
                overflowY: 'scroll',
                overflowX: 'hidden',
                background: '#fafafa',
                borderRight: '1px solid #E2E8F0',
                paddingTop: 0,
                boxSizing: 'border-box',
                zIndex: 100,
                scrollbarWidth: 'none', // Firefox
                msOverflowStyle: 'none',
              }}
            >
              <div style={{ height: 12 }} />
              <div
                style={{
                  height: 34,
                  paddingLeft: 12,
                  fontWeight: 600,
                  fontSize: 18,
                  borderBottom: '1px solid #E2E8F0',
                }}
              >
                Sprints
              </div>
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={(event) => {
                  handleDragEnd(event);
                  setActiveType(null);
                }}
                onDragStart={(event) => {
                  const type = event.active.data.current?.type;
                  setActiveType(type);

                  if (type === 'TASK') {
                    const taskId = event.active.id;
                    const sourceEpicId = event.active.data.current.epicId;
                    const sourceEpic = epicsState[sourceEpicId];

                    const draggedTask = sourceEpic?.tasks?.find(
                      (t) => t.issue_id === taskId,
                    );

                    setActiveTask(draggedTask || null);
                  }

                  if (type === 'EPIC') {
                    setActiveTask(null);
                  }
                }}
              >
                <SortableContext
                  items={sortedEpics.map(([epicId]) => epicId)}
                  strategy={verticalListSortingStrategy}
                >
                  {sortedEpics.map(([epicId, epicObj]) => (
                    <SortableEpic
                      key={epicId}
                      epicId={epicId}
                      epicObj={epicObj}
                    >
                      <div key={epicId}>
                        {/* Epic Row */}
                        <div
                          style={{
                            height: 38,
                            borderBottom: '1px solid #E2E8F0',
                            padding: '6px 10px',
                            cursor: 'pointer',
                            fontWeight: 500,
                            zIndex: 1000,
                            fontSize: '16px',
                          }}
                        >
                          <Col
                            style={{
                              // width: 390, // match the sum of sticky columns in task row
                              paddingLeft: 12,
                              // borderRight: '1px solid #d1d5db',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 8,
                              //   backgroundColor: '#f3f4f6', // match row background to prevent overlap
                              zIndex: 99,
                              // height: 34,
                              backgroundColor: '#fff',
                              fontSize: 'inherit', // ensure it floats above timeline
                            }}
                          >
                            <span
                              onClick={() => toggleEpic(epicId)}
                              style={{
                                cursor: 'pointer',
                                fontSize: 'inherit',
                              }}
                            >
                              {expandedEpics[epicId] ? (
                                <DownOutlined />
                              ) : (
                                <RightOutlined />
                              )}
                            </span>

                            <input
                              type="checkbox"
                              onChange={(e) => {
                                setCheckedEpicIds((prev) => {
                                  if (e.target.checked) {
                                    return [...prev, epicId];
                                  } else {
                                    return prev.filter((id) => id !== epicId);
                                  }
                                });
                              }}
                            />

                            <ThunderboltOutlined
                              style={{
                                color: '#884B9E',
                                fontSize: 'inherit',
                              }}
                            />

                            <div
                              style={{
                                display: 'grid',
                                width: '100%',
                                maxWidth: '100%',
                                overflow: 'visible',
                              }}
                            >
                              {/* Epic title */}
                              <div
                                style={{
                                  textOverflow: 'ellipsis',
                                  overflow: 'hidden',
                                  whiteSpace: 'nowrap',
                                }}
                                onClick={() => {
                                  handleEpicClick(epicObj);
                                }}
                              >
                                {epicObj.epic_key} {epicObj.name}
                              </div>
                              <div
                                style={{
                                  overflow: 'visible',
                                  position: 'relative',
                                }}
                              >
                                <EpicProgressBar
                                  task_status_count={epicObj?.task_status_count}
                                />
                              </div>
                            </div>

                            {[1, 2, 3].includes(roleId) && (
                              <PlusOutlined
                                style={{
                                  marginLeft: '65px',
                                  cursor: 'pointer',
                                  fontSize: 'inherit',
                                }}
                                onClick={() => handleOpenTaskInput(epicId)}
                              />
                            )}

                            {[1, 2, 3].includes(roleId) && (
                              <TimelineMenu
                                epicobj={epicObj}
                                projectId={projectId}
                              />
                            )}
                          </Col>
                        </div>

                        {/* Tasks under Epic */}
                        {expandedEpics[epicId] &&
                          epicObj.tasks.map((t) => (
                            <DraggableTask
                              key={t.issue_id}
                              task={t}
                              epicId={epicId}
                              onTaskClick={handletaskmodal}
                              activeType={activeType}
                            >
                              <div
                                key={t.issue_id}
                                style={{
                                  height: 38,
                                  padding: '4px 20px',
                                  // borderBottom: '1px solid #F1F1F1',
                                  fontSize: 14,
                                  zIndex: 1000,
                                }}
                              >
                                <Row
                                  style={{
                                    height: 32,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0,
                                    flexWrap: 'nowrap',
                                    position: 'relative',
                                    paddingLeft: 2,
                                    borderBottom: '1px solid #E2E8F0',
                                  }}
                                >
                                  <Col
                                    style={{
                                      minWidth: 100,
                                      width: '100%',
                                      maxWidth: 160,
                                      paddingLeft: 16,
                                      borderRight: '1px solid #e5e7eb',
                                      fontWeight: 500,
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                      backgroundColor: '#fff',
                                      zIndex: 99,
                                      height: 32,
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '6px',
                                      fontSize: 'inherit',
                                    }}
                                  >
                                    {getIssueIcon(t.issue_name)}
                                    {t.issue_key}
                                  </Col>

                                  {/* Task Title */}
                                  <Col
                                    style={{
                                      minWidth: 150,
                                      width: '100%',
                                      maxWidth: 300,
                                      paddingLeft: 12,
                                      paddingRight: 8,
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis',
                                      cursor: 'pointer',
                                      backgroundColor: '#fff',
                                      zIndex: 99,
                                      height: 32,
                                      display: 'flex',
                                      alignItems: 'center',
                                      fontSize: 'inherit', // ✅ vertically center
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        height: 32,
                                        fontSize: 'inherit',
                                      }}
                                    >
                                      <span>{t.issue_title}</span>
                                    </span>
                                  </Col>

                                  {/* Status + Assignee */}
                                  <Col
                                    style={{
                                      minWidth: 120,
                                      width: 'auto',
                                      maxWidth: 180,
                                      paddingLeft: 2,
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 5,
                                      backgroundColor: '#fff',
                                      zIndex: 99,
                                      height: 32,
                                      flexShrink: 0,
                                      fontSize: 'inherit',
                                    }}
                                  >
                                    {/* <Badge
                                        bg="transparent"
                                        color={color}
                                        fontSize="0.8em"
                                        p={1}
                                      >
                                        {t.task_status || ''}
                                      </Badge> */}
                                    {(() => {
                                      const { bg, color } = getStatusColors(
                                        t.task_status,
                                      );
                                      return (
                                        <Badge
                                          bg={bg}
                                          color={color}
                                          fontSize="0.8em"
                                          px={2}
                                          py={1}
                                          borderRadius="md"
                                        >
                                          {t.issue_status || ''}
                                        </Badge>
                                      );
                                    })()}

                                    <HStack spacing={2} alignItems="center">
                                      {t.assignee_name ? (
                                        <UserAvatar
                                          username={t.assignee_name}
                                          size={24}
                                        />
                                      ) : (
                                        <HStack spacing={1} color="gray.500">
                                          <MdOutlinePerson size={20} />
                                        </HStack>
                                      )}
                                    </HStack>
                                  </Col>
                                </Row>
                              </div>
                            </DraggableTask>
                          ))}
                        {showTaskInputForEpic[epicId] && (
                          <Row
                            style={{
                              height: 32,
                              alignItems: 'center',
                              borderBottom: '1px solid #f3f4f6',
                              backgroundColor: '#fffefc',
                            }}
                          >
                            <Col
                              style={{
                                // marginTop: '5px',
                                width: sidebarWidth,
                                paddingLeft: 80,
                                // borderRight: '1px solid #d1d5db',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                left: 0,
                              }}
                            >
                              {/* <input
                                  placeholder="Enter task title"
                                  value={newTaskTitles[epicId] || ''}
                                  onChange={(e) =>
                                    setNewTaskTitles((prev) => ({
                                      ...prev,
                                      [epicId]: e.target.value,
                                    }))
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      handleCreateTask(epicId, epicObj); 
                                    }
                                  }}
                                  autoFocus
                                  style={{
                                    width: sidebarWidth - 150,
                                    padding: '4px 8px',
                                    border: '0.5px solid #d0bfff',
                                    borderRadius: 4,
                                    outline: 'none',
                                  }}
                                /> */}
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 8,
                                  width: sidebarWidth - 150,
                                }}
                              >
                                {/* Dynamic Issue Type Select */}
                                <Select
                                  value={selectedIssueTypeId}
                                  onChange={(value) =>
                                    setSelectedIssueTypeId(value)
                                  }
                                  size="small"
                                  style={{ width: 60 }}
                                  dropdownStyle={{ zIndex: 99999 }}
                                  popupMatchSelectWidth={false}
                                  optionLabelProp="label"
                                >
                                  {issueTypes.map((type) => (
                                    <Select.Option
                                      key={type.issue_type_id}
                                      value={type.issue_type_id} // same as old: "task" | "story" | "bug"
                                      label={
                                        <div style={{ marginTop: 5 }}>
                                          {getIcon(type.issue_type, 18)}
                                        </div>
                                      }
                                    >
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: 6,
                                        }}
                                      >
                                        {getIcon(type.issue_type, 18)}
                                        <span>
                                          {type.issue_type.charAt(0) +
                                            type.issue_type
                                              .slice(1)
                                              .toLowerCase()}
                                        </span>
                                      </div>
                                    </Select.Option>
                                  ))}
                                </Select>

                                {/* Title Input */}
                                <input
                                  placeholder="Enter task title"
                                  value={newTaskTitles[epicId] || ''}
                                  onChange={(e) =>
                                    setNewTaskTitles((prev) => ({
                                      ...prev,
                                      [epicId]: e.target.value,
                                    }))
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      handleCreateTask(
                                        epicId,
                                        epicObj,
                                        selectedIssueTypeId,
                                      );
                                    }
                                  }}
                                  style={{
                                    flex: 1,
                                    padding: '7px 8px',
                                    border: '0.5px solid #d0bfff',
                                    borderRadius: 4,
                                    outline: 'none',
                                    height: 32,
                                    boxSizing: 'border-box',
                                  }}
                                />
                              </div>

                              <button
                                onClick={() =>
                                  handleCreateTask(epicId, epicObj)
                                }
                              >
                                <CheckOutlined />
                              </button>

                              <button
                                onClick={() =>
                                  setShowTaskInputForEpic((prev) => ({
                                    ...prev,
                                    [epicId]: false,
                                  }))
                                }
                              >
                                <CloseOutlined />
                              </button>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </SortableEpic>
                  ))}
                </SortableContext>
                {[1, 2, 3].includes(roleId) && (
                  <Row
                    style={{
                      height: 40,
                      alignItems: 'center',
                      background: '#fafafa',
                      borderTop: '0.5px solid #d0bfff',
                      paddingLeft: 12,
                      cursor: 'pointer',
                    }}
                  >
                    {showCreateEpicInput ? (
                      <>
                        <Col
                          style={{
                            width: leftColWidth + 40,
                            paddingLeft: 12,
                            // borderRight: '1px solid #d1d5db',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            zIndex: 99,
                            backgroundColor: '#fff',
                          }}
                        >
                          <input
                            type="text"
                            value={newEpicName}
                            onChange={(e) => setNewEpicName(e.target.value)}
                            placeholder="New epic name"
                            style={{
                              width: 300,
                              padding: '4px 8px',
                              border: '0.5px solid #d0bfff',
                              borderRadius: 4,
                              outline: 'none',
                              zIndex: 99,
                            }}
                            autoFocus
                          />
                          <button
                            style={{
                              marginLeft: 8,
                              zIndex: 99,
                              height: 34,
                              backgroundColor: '#fff',
                            }}
                            onClick={handleCreateEpic}
                          >
                            <CheckOutlined />
                          </button>
                          <button
                            style={{
                              marginLeft: 4,
                              zIndex: 99,
                              height: 34,
                              backgroundColor: '#fff',
                            }}
                            onClick={() => {
                              setShowCreateEpicInput(false);
                              setNewEpicName('');
                            }}
                          >
                            <CloseOutlined />
                          </button>
                        </Col>
                      </>
                    ) : (
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#884B9E',
                          fontWeight: 500,
                          cursor: 'pointer',
                          height: 34,
                          backgroundColor: '#fff',
                          zIndex: 100,
                        }}
                        onClick={() => setShowCreateEpicInput(true)}
                      >
                        <PlusOutlined style={{ marginRight: 6 }} /> Create Epic
                      </span>
                    )}
                  </Row>
                )}
                <div
  style={{
    height:20,
    borderTop: '0.5px solid #d0bfff',
    background: '#fafafa',
    boxSizing: 'border-box',
    width: '100%',
    flexShrink: 0,
  }}
/>


                <DragOverlay>
                  {activeTask && (
                    <div
                      style={{
                        background: '#b45309',
                        color: '#fff',
                        borderRadius: 6,
                        padding: '6px 12px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      <strong>{activeTask.issue_key}</strong> —{' '}
                      {activeTask.issue_title}
                    </div>
                  )}
                </DragOverlay>
              </DndContext>
            </div>
            <div
              style={{
                width: 6,
                cursor: 'col-resize',
                zIndex: 2000,
                background: 'transparent',
              }}
              onMouseDown={startResize}
            />
            <div
              ref={timelineScrollRef}
              onScroll={onTimelineScroll}
              className="timeline-right"
              style={{
                flex: 1,
                overflow: 'auto',
                position: 'relative',
                background: '#f5f5f5',
                minHeight: 0, // important so child can scroll
              }}
            >
              <div style={{ position: 'relative', marginTop: 0 }}>
                <div
                  style={{
                    position: 'fixed',
                    top: '300px',
                    background: '#d5d8deff',
                    borderBottom: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 600,
                    transform: `translateX(-${scrollLeft}px)`, // Moves horizontally
                    zIndex: 40,
                    height: 46,
                    width: 'max-content',
                    left: scale === 'weekly' ? 310 + sidebarWidth : '',
                  }}
                >
                  {(() => {
                    if (scale === 'monthly') {
                      return months.map((d, i) => {
                        const start = d.startOf('month').valueOf();
                        const end = d.endOf('month').valueOf();
                        const fullWidth =
                          ((end - start) / 86400000) * PIXELS_PER_DAY;
                        const left =
                          ((start - allStart) / 86400000) * PIXELS_PER_DAY;

                        return (
                          <React.Fragment key={i}>
                            {/* Start of month line */}
                            <div
                              style={{
                                position: 'absolute',
                                left,
                                top: 0,
                                height: '500px',
                                width: 2,
                                backgroundColor: '#E2E8F0',
                                zIndex: 500, // grey line
                              }}
                            />

                            {/* Full-width label background with centered text */}
                            <div
                              style={{
                                position: 'absolute',
                                left,
                                width: fullWidth,
                                top: 0,
                                background: '#f0f1f2', // background color across full width
                                height: '52px',
                                textAlign: 'center',
                                lineHeight: '35px',
                                fontSize: 16,
                                fontWeight: 600,
                                whiteSpace: 'nowrap',
                                borderRadius: '4px',
                                alignContent: 'center',
                              }}
                            >
                              {`${d.format("MMMM 'YY")}`}{' '}
                              {/* Example: April '26 */}
                            </div>
                            {isActiveInRange && (
                              <>
                                {/* Triangle pointer */}
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 52, // adjust to match monthly header height
                                    left: activeLeft + 5.5,
                                    width: 0,
                                    height: 0,
                                    borderLeft: '6px solid transparent',
                                    borderRight: '6px solid transparent',
                                    borderTop: '10px solid #3b82f6',
                                    zIndex: 960,
                                  }}
                                />

                                {/* Vertical active line */}
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 60,
                                    left: activeLeft + 10.5,
                                    width: 2,
                                    height: '100vh',
                                    backgroundColor: '#3b82f6',
                                    zIndex: 950,
                                  }}
                                />
                              </>
                            )}
                          </React.Fragment>
                        );
                      });
                    }

                    if (scale === 'quarterly') {
                      const quarters = [];
                      let qStart = dayjs(allStart).startOf('month');
                      const qEnd = dayjs(allEnd).endOf('month');

                      // Build quarterly ranges (3 months each)
                      while (qStart.isBefore(qEnd)) {
                        const qEndDate = qStart.add(2, 'month').endOf('month'); // Quarter = 3 months
                        quarters.push({ start: qStart, end: qEndDate });
                        qStart = qStart.add(3, 'month').startOf('month');
                      }

                      return quarters.map((q, i) => {
                        const fullWidth =
                          ((q.end.valueOf() - q.start.valueOf()) / 86400000) *
                          PIXELS_PER_DAY;
                        const left =
                          ((q.start.valueOf() - allStart) / 86400000) *
                          PIXELS_PER_DAY;

                        return (
                          <React.Fragment key={i}>
                            {/* Start of quarter line */}
                            <div
                              style={{
                                position: 'absolute',
                                left,
                                top: 0,
                                height: '500px',
                                width: 2,
                                backgroundColor: '#E2E8F0',
                                zIndex: 500, // grey line
                              }}
                            />

                            {/* Full-width label background with centered text */}
                            <div
                              style={{
                                position: 'absolute',
                                left,
                                width: fullWidth,
                                top: 0,
                                background: '#f0f1f2', // full background bar
                                height: '52px',
                                textAlign: 'center',
                                lineHeight: '35px',
                                fontSize: 16,
                                fontWeight: 600,
                                whiteSpace: 'nowrap',
                                borderRadius: '4px',
                                alignContent: 'center',
                              }}
                            >
                              {`${q.start.format('MMMM')} – ${q.end.format(
                                'MMMM',
                              )} '${q.start.format('YY')}`}
                            </div>
                            {isActiveInRange && (
                              <>
                                {/* Triangle pointer */}
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 52,
                                    left: activeLeft + 5.5,
                                    width: 0,
                                    height: 0,
                                    borderLeft: '6px solid transparent',
                                    borderRight: '6px solid transparent',
                                    borderTop: '10px solid #3b82f6',
                                    zIndex: 960,
                                  }}
                                />

                                {/* Vertical active line */}
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 60,
                                    left: activeLeft + 10.5,
                                    width: 2,
                                    height: '100vh',
                                    backgroundColor: '#3b82f6',
                                    zIndex: 950,
                                  }}
                                />
                              </>
                            )}
                          </React.Fragment>
                        );
                      });
                    }
                    if (scale === 'weekly') {
                      const MS_PER_DAY = 86400000;

                      // Define today's date (or pass activeDay as prop)
                      const activeDay = dayjs(); // <-- Change if needed

                      // Build months
                      const months = [];
                      let m = dayjs(allStart).startOf('month');
                      const end = dayjs(allEnd).endOf('month');

                      while (m.isBefore(end)) {
                        const start = m.startOf('month');
                        const endOfMonth = m.endOf('month');
                        const totalDays = endOfMonth.diff(start, 'day') + 1;

                        months.push({
                          start,
                          end: endOfMonth,
                          totalDays,
                        });

                        m = m.add(1, 'month');
                      }

                      return (
                        <>
                          {/* MONTH HEADERS */}
                          {months.map((m, i) => {
                            const monthLeft =
                              ((m.start.valueOf() - allStart) / MS_PER_DAY) *
                              PIXELS_PER_DAY;

                            const monthWidth = m.totalDays * PIXELS_PER_DAY;
                            const monthEndLeft = monthLeft + monthWidth;

                            return (
                              <React.Fragment key={`month-${i}`}>
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: monthLeft,
                                    width: monthWidth,
                                    height: 40,
                                    background: '#f0f1f2',
                                    textAlign: 'center',
                                    lineHeight: '40px',
                                    fontSize: 16,
                                    fontWeight: 600,
                                    borderRadius: 4,
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {m.start.format('MMMM YYYY')}
                                </div>

                                {/* END OF MONTH BORDER */}
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: monthEndLeft,
                                    height: '100vh',
                                    width: 2,
                                    backgroundColor: '#E2E8F0',
                                  }}
                                />
                              </React.Fragment>
                            );
                          })}

                          {/* DAYS BELOW MONTHS */}
                          {months.map((m, i) => {
                            const monthLeft =
                              ((m.start.valueOf() - allStart) / MS_PER_DAY) *
                              PIXELS_PER_DAY;

                            return (
                              <React.Fragment key={`days-${i}`}>
                                {[...Array(m.totalDays)].map((_, dayIndex) => {
                                  const day = m.start.add(dayIndex, 'day');
                                  const dayLeft =
                                    monthLeft + dayIndex * PIXELS_PER_DAY;

                                  const isActive =
                                    day.format('YYYY-MM-DD') ===
                                    activeDay.format('YYYY-MM-DD');

                                  return (
                                    <React.Fragment
                                      key={`day-${i}-${dayIndex}`}
                                    >
                                      {/* DAY BOX */}
                                      <div
                                        style={{
                                          position: 'absolute',
                                          top: 30,
                                          left: dayLeft,
                                          width: PIXELS_PER_DAY,
                                          height: 23,
                                          borderRight: '1px solid #d1d5db',
                                          borderBottom: '1px solid #d1d5db',
                                          textAlign: 'center',
                                          lineHeight: '26px',
                                          fontSize: 12,
                                          background: isActive
                                            ? '#dbeafe'
                                            : dayIndex % 2 === 0
                                              ? '#fafafa'
                                              : '#f2f2f2',
                                          color: isActive ? 'black' : '#333',
                                          fontWeight: isActive ? 600 : 400,
                                          zIndex: isActive ? 910 : 1,
                                        }}
                                      >
                                        {day.date()}
                                      </div>

                                      {/* ACTIVE DAY VERTICAL LINE */}
                                      {isActive && (
                                        <>
                                          {/* TRIANGLE POINTER */}
                                          <div
                                            style={{
                                              position: 'absolute',
                                              top: 52, // Adjust based on your timeline header height
                                              left: dayLeft + 5.5,
                                              width: 0,
                                              height: 0,
                                              borderLeft:
                                                '6px solid transparent',
                                              borderRight:
                                                '6px solid transparent',
                                              borderTop: '10px solid #3b82f6',
                                              zIndex: 960,
                                            }}
                                          />

                                          {/* VERTICAL LINE */}
                                          <div
                                            style={{
                                              position: 'absolute',
                                              top: 60, // Just below the triangle
                                              left: dayLeft + 10.5,
                                              width: 2,
                                              height: '100vh', // Adjust as needed
                                              backgroundColor: '#3b82f6',
                                              zIndex: 950,
                                            }}
                                          />
                                        </>
                                      )}
                                    </React.Fragment>
                                  );
                                })}
                              </React.Fragment>
                            );
                          })}
                        </>
                      );
                    }

                    // default daily
                    return days.map((d, i) => (
                      <div
                        key={i}
                        style={{
                          position: 'absolute',
                          left:
                            ((ms(d) - allStart) / 86400000) * PIXELS_PER_DAY,
                          width: PIXELS_PER_DAY,
                          textAlign: 'center',
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        {dayjs(d).format('DD MMM')}
                      </div>
                    ));
                  })()}
                </div>
                {/* Epics + Tasks Bars */}
                <div
                  style={{
                    width: TIMELINE_WIDTH,
                    height: 38, // FIX: required for single row
                    borderBottom: '1px solid #E2E8F0',
                    position: 'relative',
                    marginTop: 10,
                    // display: "flex",            // FIX: force items in one row
                    alignItems: 'center',
                    left: scale === 'weekly' ? 240 : '',
                  }}
                >
                  {sprints?.map((s) => {
                    const overlapping = isOverlapping(s, sprints);
                    const isExpanded = expandedSprintId === s.sprint_id;

                    const toggleExpand = () => {
                      if (isExpanded) setExpandedSprintId(null);
                      else setExpandedSprintId(s.sprint_id);
                    };

                    return (
                      <ResizableBar
                        key={s.sprint_id}
                        start={ms(s.start_date)} // ms() converts string -> number; keep for initial data
                        end={ms(s.end_date)}
                        allStartMs={allStartMs}
                        PIXELS_PER_DAY={PIXELS_PER_DAY}
                        bar_name="sprint-bar"
                        MS_PER_PIXEL={MS_PER_PIXEL}
                        color={COLORS.sprint}
                        label={s.sprint_name}
                        scale={scale}
                        isOverlapping={overlapping}
                        isExpanded={!overlapping || isExpanded}
                        onExpandClick={toggleExpand}
                        onUpdate={(newStart, newEnd) => {
                          handleSprintUpdateDates(
                            s.sprint_id,
                            newStart,
                            newEnd,
                            s,
                          );
                          setExpandedSprintId(null);
                        }}
                      />
                    );
                  })}
                </div>

                {/* --- EPICS + TASKS START BELOW --- */}
                <div style={{ width: TIMELINE_WIDTH }}>
                  {Object.entries(epicsState)
                    .sort((a, b) => (a[1].position || 0) - (b[1].position || 0))
                    .map(([epicId, epicObj]) => (
                      <React.Fragment key={epicId}>
                        {/* Epic Row */}
                         <SortableEpic
                      key={epicId}
                      epicId={epicId}
                      epicObj={epicObj}
                    >
                        <div
                          style={{
                            height: 38,
                            borderBottom: '1px solid #E2E8F0',
                            width: `${totalWidth}px`,
                            position: 'relative',
                            left: scale === 'weekly' ? 240 : '',
                          }}
                        >
                          <ResizableBar
                            start={ms(epicObj.start_date)}
                            end={ms(epicObj.due_date)}
                            allStartMs={allStartMs}
                            PIXELS_PER_DAY={PIXELS_PER_DAY}
                            MS_PER_PIXEL={MS_PER_PIXEL}
                            color={epicObj.color ? epicObj.color : COLORS.epic}
                            label={epicObj.name}
                            onHandleClick={() => handleEpicClick(epicObj)}
                            bar_name={'epic-bar'}
                            scale={scale}
                            onUpdate={(newStart, newEnd) =>
                              handleEpicUpdateDates(
                                epicId,
                                newStart,
                                newEnd,
                                epicObj.name,
                              )
                            }
                            details={epicObj}
                          />
                        </div>

                        {/* Task Rows */}
                        {expandedEpics[epicId] &&
                          epicObj.tasks.map((t) => (
                            <div
                              key={t.issue_id}
                              style={{
                                height: 38,
                                borderBottom: '1px solid #F1F1F1',
                                position: 'relative',
                                left: scale === 'weekly' ? 240 : '',
                              }}
                            >
                              {t.start_date && (
                                <ResizableBar
                                  start={ms(t.start_date)}
                                  end={ms(t.due_date)}
                                  allStartMs={allStartMs}
                                  PIXELS_PER_DAY={PIXELS_PER_DAY}
                                  MS_PER_PIXEL={MS_PER_PIXEL}
                                  epic_start={ms(epicObj.start_date)}
                                  epic_end={ms(epicObj.due_date)}
                                  onHandleClick={() => handleOpentask(t)}
                                  bar_name={'task-bar'}
                                  color={
                                    t.task_status === 'DONE'
                                      ? '#82B536'
                                      : t.task_status === 'TO DO'
                                        ? '#8C8F97'
                                        : COLORS.task
                                  }
                                  label={t.task_title}
                                  scale={scale}
                                  onUpdate={(newStart, newEnd) =>
                                    handleTaskUpdateDates(
                                      t.issue_id,
                                      newStart,
                                      newEnd,
                                      t,
                                    )
                                  }
                                  details={t}
                                />
                              )}
                            </div>
                          ))}
                           
                          </SortableEpic>
                      </React.Fragment>
                    ))}
                       <div
    style={{
      height: 40,
      borderBottom: '1px solid #F1F1F1',
      position: 'relative',
      left: scale === 'weekly' ? 240 : '',
    }}
  /> 
                  

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* </Split> */}
      {epicmodalVisible && [1, 2, 3, 4, 5].includes(roleId) && (
        <TimelineEpicmodal
          isOpen={epicmodalVisible}
          epicDetails={selectedEpic} // 👈 now you pass the clicked epic
          onClose={handleCloseEpicModal}
          projectId={projectId}
          fetchData={fetchData}
          opentaskmodal={handleOpentask}
          issueTypes={issueTypes}
          task={selectedTask}
          // you can also pass assigneeList, statusList, etc.
        />
      )}
      {taskmodalvisibe && (
        <TimelineTaskmodal
          key={selectedTask.issue_id}
          isOpen={taskmodalvisibe}
          onClose={handleClosetaskmodal}
          task={selectedTask}
          projectId={projectId}
          fetchData={fetchData}
          openSubtaskModal={handleOpenSubtask}
          openepicmodal={handleEpicClick}

          // you can also pass assigneeList, statusList, etc.
        />
      )}

      {showsprintmodal && (
        <SprintModal
          isOpen={showsprintmodal}
          onClose={() => setshowSprintModal(false)}
          taskdetails={recentlyCreatedTask}
          projectId={projectId}
          // getTaskBoardDetails={getTaskBoardDetails}
        />
      )}

      {openSubTaskModal && (
        <Timelinesubtaskmodal
          isOpen={openSubTaskModal}
          onClose={handlesubtaskmodal}
          subtaskdetails={selectedSubtask}
          projectId={projectId}
          task={selectedTask}
        />
      )}

      {/* Your content goes here */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          position: 'fixed',
          bottom: 50, // distance from the top
          right: 50, // distance from the right
          width: 'auto', // optional: full width to keep flex working
          zIndex: 1000, // make sure it's above other elements
          borderRadius: 8,
          border: '2px solid #727272ff',
          padding: 4,
        }}
        data-tour="timeline-view"
      >
        <div>
          <Segmented
            value={scale}
            onChange={handleScaleChange}
            size="middle"
            options={Object.keys(TIME_SCALES).map((key) => ({
              label:
                key === 'daily'
                  ? 'Today'
                  : key.charAt(0).toUpperCase() + key.slice(1),
              value: key,
            }))}
          />
        </div>
      </div>
    </Card>
  );
};

export default TimelineDashboard;
